<template>
  <main>
    <a-modal
      :visible="visible"
      :title="processForm.name"
      @ok="handleOk"
      @cancel="handleCancel"
      width="100%"
      class="full-modal"
      :zIndex="10000000000"
    >
        <div class="wrap-input-copy">
          <label for="">{{ $t('url_library') }}</label>
        <a-input v-model="urlPreview" placeholder="" size="large" class="input-copy" disabled>
          <a-tooltip slot="suffix">
            <a-button @click="onCopy">
              <a-icon type="copy" style="color: rgba(0,0,0,.45)" class="modal-btn-copy" />
            </a-button>
            <a-button class="modal-btn-preview" @click="onPreview">
              <a-icon type="eye" style="color: rgba(0,0,0,.45)" />
            </a-button>
          </a-tooltip>
        </a-input>
      </div>
      <iframe :src="urlPreview" frameborder="0" class="iframe"></iframe>
    </a-modal>
    <section class="page-header">
        <div class="d-flex align-items-center">
          <span class="clickable mr-2" @click="$router.go(-1)" v-if="showGoBackButton">
            <i class="mdi mdi-chevron-left" style="font-size: 2rem"></i>
          </span>
          <div>
            <h2 class="mb-0">{{ $t('documents_library') }}</h2>
            <h6 class="mt-0">{{ $t('documents_type') }}</h6>
          </div>
        </div>
        <div class="d-flex">
          <div
            v-for="(item, index) of stepsButtons"
            :key="index"
            :class="{'ml-3': item.condition}"
          >
            <lm-button-v2
              v-if="item.condition"
              v-bind="item"
              :shape="item.icon ? 'circle': null"
              :loading="isProcessing"
              @click="item.click"
            >
              {{ !item.icon ? item.label : null }}
            </lm-button-v2>
          </div>
        </div>
      </section>

    <b-row class="page-content">
      <b-col cols="12" class="bg-light rounded-lg">
        <div class="d-none d-md-block">
          <a-steps v-model="currentStep" type="navigation" size="small">
            <a-step :title="$t('library_configuration')" status="0" />
            <a-step :title="$t('upload_document_types')" status="1" />
          </a-steps>
        </div>
        <!-- Step 0 -->
        <section class="p-4 rounded-lg bg-white position-relative">
        <div v-show="currentStep === 0">
          <b-row>
            <b-col md="12" cols="12">
            <LmTextInput :label="$t('name_of_library')" :placeholder="$t('name_of_library')"
              v-model="processForm.name" :v="$v.processForm.name" />
            </b-col>
          </b-row>
          <b-row>
            <LmTextInput label="Slug" placeholder="Slug" class="col-12" v-model="processForm.slug" :v="$v.processForm.name" />
          </b-row>
          <b-row>
            <LmColorPicker :label="$t('header_color')" class="col-12 mt-1" :swatches="swatches" v-model="processForm.color"
              :options="{ 'show-fallback': true, 'fallback-input-type': 'color' }" />
          </b-row>
        </div>
        <div v-show="currentStep === 1">
          <b-card no-body class="border mt-4">
          <b-tabs card>
            <b-tab :title="$t('document_types')" active>
              <b-row>
                <b-col md="4" cols="12">
                  <lm-button-v2
                    variant="info"
                    buttonClass="btn-info btn-block"
                    v-b-modal.documents-datatable-modal
                  >
                  {{$t('browse')}}
                  </lm-button-v2>
                </b-col>
                <b-col v-if="processForm.documentTypes.length" cols="12" class="mt-3">
                  <a-table
                          bordered
                          :columns="tableColumns"
                          :data-source="tableData"
                          :loading="isTableLoading"
                          :customRow="customRow"
                          :customHeaderRow="customHeaderRow"
                          :pagination="{ hideOnSinglePage: true }"
                        >
                        <span slot="action" slot-scope="text, record">
                            <div class="d-flex" style="column-gap: .5rem">
                              <a-tooltip title="Eliminar">
                                <lm-button-v2 shape="circle" icon="delete" @click="onRemoveDocument(record)" v-if="record.canBeDeleted" />
                              </a-tooltip>
                            </div>
                          </span>
                      </a-table>
                </b-col>
              </b-row>
              <b-modal
              id="documents-datatable-modal"
              size="xl"
              scrollable hide-header
              @ok="onConfirmAppDocuments"
              :cancel-title="$t('cancel')" :ok-title="$t('confirm')"
              >
                <LmDataTable
                ref="datatable-document-types"
                slug="tipos-de-documentos-biblioteca"
                hideButtons />
              </b-modal>
              <b-modal
                id="document-types-datatable-modal"
                size="xl"
                :cancel-title="$t('cancel')"
                :ok-title="$t('confirm')"
              >
                <LmDataTable
                  onSelect="onSelectDocuments"
                  slug="tipos-de-documento-todos"
                  hideButtons
                />
              </b-modal>
            </b-tab>
          </b-tabs>
        </b-card>
        </div>
      </section>
      <div class="d-flex m-4" style="gap: .5rem">
        <lm-button-v2  click="onPrevStep" v-if="showPrevButton" @click="onPrevStep">
          Anterior
        </lm-button-v2>
        <lm-button-v2  click="onNextStep" v-if="showNextButton" @click="onNextStep">
          Siguiente
        </lm-button-v2>
      </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>

// Components
import LmDataTable from '@/components/lmDataTable/table'
import LmSelect from '@/components/form/elements/LmSelect'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
// Utils
import draggable from 'vuedraggable'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {
  mixins: [lmToasts],
  components: {
    draggable,
    LmSelect,
    LmButton,
    LmTextInput,
    LmColorPicker,
    LmTreeSelect,
    LmButtonV2,
    LmDataTable
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectBack: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      apiUrl: process.env.VUE_APP_API_URL,
      currentStep: 0,
      showGoBackButton: false,
      documentsChange: false,
      isProcessing: false,
      isTableLoading: false,
      isDeleted: false,
      initialSlug: '',
      visible: false,
      processForm: {
        name: '',
        slug: '',
        color: '#ffffff',
        documentTypes: [],
        internalDocuments: []
      },
      swatches: [
        ['#F6648B', '#F493A7', '#F891A6', '#FFCCD5'],
        ['#a27bff', '#b99cff', '#d0bdff', '#e8deff'],
        ['#74ebe3', '#96f0ea', '#b9f5f1', '#dcfaf8'],
        ['#ffb748', '#ffc976', '#ffdba3', '#ffedd1'],
        ['#000000', '#999999', '#cccccc', '#ffffff']
      ],
      canAddExternalRecipients: true
    }
  },
  validations: {
    processForm: {
      name: {
        required
      },
      slug: {
        required
      }
    }
  },
  computed: {
    urlPreview () {
      let origin = window.location.origin
      return origin + '/bibliotecapublica/' + this.processForm.slug
    },
    tableColumns () {
      return [
        {
          title: 'Nombre',
          dataIndex: 'typeName'
        },
        {
          title: 'Alias',
          dataIndex: 'typeAlias'
        },
        {
          title: 'Acciones',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    tableData () {
      return this.processForm.documentTypes.map((el, index) => {
        return {
          key: index,
          order: el.order,
          canBeCorrected: el.canBeCorrected || false,
          canBeDeleted: el.canBeDeleted || false,
          metadata: el.metadata,
          created_at: moment(el.created_at).format('DD [de] MMM, YYYY - HH:mm'),
          ...el.document,
          documentNumber: el.document.documentNumber || 'N/A'
        }
      })
    },
    stepsButtons () {
      return [
        {
          label: this.$t('cancel'),
          type: 'secondary',
          condition: true,
          click: () => this.onCancel()
        },
        {
          label: this.$t('save'),
          icon: null,
          type: 'primary',
          condition: this.showSaveButton,
          click: () => this.onSave()
        },
        {
          label: this.$t('erase'),
          type: 'danger',
          condition: this.showDeleteButton,
          click: () => this.onDelete()
        },
        {
          label: this.$t('restore_logic'),
          type: 'success',
          condition: this.showRestoreButton,
          click: () => this.onRestore()
        },
        {
          label: this.$t('view_library'),
          // icon: 'eye',
          type: 'secondary',
          condition: this.showOnPreview,
          click: () => this.onPreview()
        }
      ]
    },
    showSaveButton () {
      return this.processForm?.name && this.processForm?.slug && this.processForm.documentTypes.length > 0
    },
    showDeleteButton () {
      return this.isOnEditMode && !this.isDeleted
    },
    showRestoreButton () {
      return this.isOnEditMode && this.isDeleted
    },
    showPrevButton () {
      return this.currentStep !== 0 && !this.processWasStarted
    },
    showNextButton () {
      return this.currentStep !== 1 && !this.processWasStarted
    },
    showOnPreview () {
      return this.isOnEditMode && this.processForm.slug && (this.processForm.slug === this.initialSlug)
    },
    requestParams () {
      const paylaod = {
        ...this.processForm
      }
      return paylaod
    }
  },
  methods: {
    onCopy () {
      this.$copyText(this.urlPreview).then((e) => {
        alert(`${this.$t('copied')}`)
      }, function (e) {
        console.log(e)
      })
    },
    showModal () {
      this.visible = true
    },
    handleOk () {
      this.visible = false
    },
    handleCancel () {
      this.visible = false
    },
    onPreview () {
      const route = `/bibliotecapublica/${this.processForm.slug}`
      // this.$router.push(route)
      window.open(route, '_blank')
    },
    async onSave () {
      try {
        this.isProcessing = true
        if (this.isOnEditMode) {
          const res = await commonsApi.axiosPutWrapper(`/documentlibrary/edit/${this.$route.params.id}`, this.requestParams)
          this.lmNotificationSuccessMessage({ message: `${this.$t('success_edit_library')}` })
          if (res.data.status === 'success') {
            this.initialSlug = this.processForm.slug
          }
        } else {
          await commonsApi.axiosPostWrapper('/documentlibrary/new', this.requestParams)
          this.lmNotificationSuccessMessage({ message: `${this.$t('success_add_library')}` })
          this.$router.push(this.pathToRedirectBack)
          // this.lmModalSuccessWithButtons({ resultTitle: `${this.$t('success_create_library')}`, btnLink: `/biblioteca/editar/${response?.data?._id}` })
        }
        this.documentsChange = false
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectBack)
    },
    async onDelete () {
      try {
        this.isProcessing = true
        const response = await commonsApi.axiosPutWrapper(`/documentlibrary/delete/${this.$route.params.id}`)
        this.lmNotificationSuccessMessage({ message: `Se elimino la librería correctamente` })
        this.isDeleted = response.data.deleted
        // this.$router.push('/inbox')
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onRestore () {
      try {
        this.isProcessing = true
        const response = await commonsApi.axiosPutWrapper(`/documentlibrary/restore/${this.$route.params.id}`)
        this.lmNotificationSuccessMessage({ message: `Se restauró la librería correctamente` })
        this.isDeleted = response.data.deleted
        // this.$router.push('/inbox')
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onRemoveDocument (item) {
      const id = item._id || item.id
      this.processForm.documentTypes = this.processForm.documentTypes.filter(el => el.id !== id)
    },
    customRow (record, index) {
      const props = {}
      if (!record.canBeCorrected && record.order !== 'N/A') {
        props.class = 'a-table-row-disabled'
      }
      props.class += ' a-table-row'
      return props
    },
    customHeaderRow (column, index) {
      return {
        class: 'a-table-header-row'
      }
    },
    async onConfirmAppDocuments () {
      try {
        this.isTableLoading = true
        const selected = this.$refs['datatable-document-types'].dataValue
        if (selected) {
          const currentDocumentsIds = this.processForm.documentTypes.map(el => el.id)
          const documentsIds = selected.filter(el => !currentDocumentsIds.includes(el.id)).map(el => el.id)

          if (!documentsIds.length) return

          const response = await commonsApi.axiosPostWrapper('/documenttypes/list-from-es', {
            ids: documentsIds,
            fields: ['id', 'typeName', 'typeAlias']
          })
          const items = response.data.items.map(el => {
            el._id = el.id
            return {
              id: el.id,
              order: 'N/A',
              canBeDeleted: true,
              canBeCorrected: false,
              document: el,
              metadata: {}
            }
          })
          this.processForm.documentTypes = [].concat(this.processForm.documentTypes, items)
          this.documentsChange = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isTableLoading = false
      }
    },
    onPrevStep () {
      this.currentStep--
    },
    onNextStep () {
      this.currentStep++
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    }
  },
  watch: {
    async currentStep (val, oldVal) {
      try {
        this.stepsMovements.push(oldVal)
        if (oldVal === 0) {
          this.step0completed = this.step0completed || !!(this.currentInitiatorType && this.currentInitiator)
        }
        if (oldVal === 1) {
          if (!this.step0completed) return
          await this.$refs['process-formbuilder'].validate()
          await this.validateForm(this.$v)
          this.step1completed = true
        }
      } catch (error) {
        if (oldVal === 1) {
          this.step1completed = false
        }
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      // Modo Edición
      if (this.isOnEditMode) {
        const library = await commonsApi.axiosGetWrapper(`/documentlibrary/${this.$route.params.id}`)
        for (const key in library?.data) {
          if (this.processForm.hasOwnProperty(key)) {
            this.processForm[key] = library.data[key]
          }
          if (key === 'deleted') {
            this.isDeleted = library.data[key]
          }
          if (key === 'slug') {
            this.initialSlug = library.data[key]
          }
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
<style>
.full-modal .ant-modal {
  max-width: 100%;
  top: 0;
  padding-bottom: 0;
}
.full-modal .ant-modal-content {
   display: flex;
  flex-direction: column;
  height: calc(100vh);
}
.full-modal .ant-modal-body {
  flex: 1;
  padding:0;
  margin:0;
}
</style>
<style scoped>
.page-header {
  position: sticky;
  top: 0;
  background-color: white;
  padding: 1rem 2rem;
  z-index: 4;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 95px;
}

.page-content {
  min-height: calc(100vh - 70px - 60px - 95px);
}

.initiators-list {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, 20%);
}

.initiators-list > article {
  transition: all .2s ease-in-out;
}
.initiators-list > article:hover, .initiators-list > article.selected {
  transform: scale(1.020);
  filter: drop-shadow(0px 3px 5px #DCDCDC);
}

.initiator-searcher-form {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(100px, 25%));
  align-items: flex-end;
}
.initiator-searcher-form #lm-button-root-wrapper {
  padding-bottom: 2px;
}

.corrected {
  background-color: gray;
}
.iframe{
  width: 100%;
  height: calc(100% - 114px);
}
.wrap-input-copy{
  padding: 15px;
  margin-bottom: 15px;
}
.modal-btn-preview{
  margin-right: -8px;
  margin-left: 4px;
}
</style>
